import { graphql } from "../gql";

export const getBatchClaimEventHistoryTimelineQueryDoc = graphql(`
  query getBatchClaimEventHistoryTimeline(
    $batchClaimId: UUID!
    $limit: Int!
    $offset: Int!
  ) {
    batchClaim(id: $batchClaimId) {
      __typename
      id
      eventHistoryTimeline(limit: $limit, offset: $offset) {
        __typename
        events {
          id
          eventType
          action
          metaData
          createdAt: created_at
        }
      }
    }
  }
`);
